// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createAppAvailabilityGet from "./appAvailability/postAppAvailabilityGet";
import createContactSubmit from "./contact/postContactSubmit";
import createHomepageGet from "./homepage/postHomepageGet";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postAppAvailabilityGet: createAppAvailabilityGet(resolvedOptions),
    postContactSubmit: createContactSubmit(resolvedOptions),
    postHomepageGet: createHomepageGet(resolvedOptions),
  };
}
